import { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { openDownloadModal } from '../../lib/download';

type NavItem =
  | { kind: 'anchor'; href: string; label: string }
  | { kind: 'route'; to: string; label: string }
  | { kind: 'action'; label: string };

const NAV_ITEMS: NavItem[] = [
  { kind: 'anchor', href: '#why', label: 'Features' },
  { kind: 'anchor', href: '#ai', label: 'AI' },
  { kind: 'anchor', href: '#pricing', label: 'Pricing' },
  { kind: 'action', label: 'Download' },
  { kind: 'route', to: '/support', label: 'Support' },
  { kind: 'route', to: '/about', label: 'Company' },
];

export default function CineNav() {
  const [scrolled, setScrolled] = useState(false);
  const { pathname } = useLocation();
  const onLanding = pathname === '/';

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header className={`cine-nav ${scrolled ? 'scrolled' : ''}`}>
      <Link to="/" className="cine-logo" aria-label="Rovera home">
        <img
          src="/branding/rovera-lockup.png"
          alt="Rovera"
          className="cine-logo-img"
          width={300}
          height={300}
          decoding="async"
        />
      </Link>
      <nav className="cine-nav-links" aria-label="Sections">
        {NAV_ITEMS.map((item) => {
          if (item.kind === 'action') {
            return (
              <button key={item.label} type="button" onClick={openDownloadModal}>
                {item.label}
              </button>
            );
          }
          if (item.kind === 'route') {
            return (
              <Link key={item.to} to={item.to}>
                {item.label}
              </Link>
            );
          }
          // Section anchors only scroll natively on the landing page itself;
          // from any other page, route home first and land on the section.
          return onLanding ? (
            <a key={item.href} href={item.href}>
              {item.label}
            </a>
          ) : (
            <Link key={item.href} to={`/${item.href}`}>
              {item.label}
            </Link>
          );
        })}
      </nav>
      <nav className="cine-nav-actions" aria-label="Get Rovera">
        <Link to="/register" className="cine-btn cine-btn-primary">
          Start Free
        </Link>
      </nav>
    </header>
  );
}
